/**
 * API `service` query values for catalog shop occasion discovery (PBI #1119).
 * Must stay aligned with ScheduledSmiles.Api.Constants.CatalogShopServiceKeys.
 */

export const CatalogShopServiceKeys = {
  ECard: 'ecard',
  Flowers: 'flowers',
  MailedCards: 'mailedCards',
  Gifts: 'gifts',
} as const;

export type CatalogShopServiceKey =
  (typeof CatalogShopServiceKeys)[keyof typeof CatalogShopServiceKeys];

/** Tab value for the public shop "All" occasion filter. */
export const PUBLIC_CATALOG_ALL_TAB = 'all';

/** URL query parameter for the active occasion tab. */
export const CATALOG_OCCASION_TAB_PARAM = 'tab';
